<template>
  <div id="page_not_found">
    <section class="bg-cl-primary py35 px20">
      <div class="container">
        <div class="row between-sm middle-xs">
          <div class="col-sm-12 col-md-5 hidden-xs">
            <img src="/assets/404-Egarderobe.png" :alt="$t('We looked everywhere.')" width="100%">
            <p class="h2 oops align-center">
              Oops!
            </p>
          </div>
          <div class="col-sm-12 col-md-7 col-xl-5 align-right align-center-xs end-sm">
            <h2 class="fs-big cl-light-gray weight-500 mt0 mb15">
              {{ $t("We've encountered a Server Error while rendering this page.") }}
            </h2>
            <p class="h4 mb40">
              {{ $t("Please try again in a few minutes.") }}
            </p>
            <div class="home-button mb40 flex end-sm center-xs">
              <button-full
                :link="{ name: 'home' }"
                class="uppercase h5 mw280"
              >
                {{ $t('Go to home page') }}
              </button-full>
            </div>
            <p class="h4">
              {{ $t('Search for products by category') }}
            </p>
            <div class="flex column bottom-lg mb40">
              <router-link
                v-for="cat in sortedCategoriesMap[mainCategoryId]"
                v-show="cat.id !== 3 && cat.id !== 206"
                :key="cat.id + 'error'"
                :to="localizedRoute(cat.url_path)"
                class="col-xs-5 uppercase h5 button-full no-underline m5"
              >
                {{ cat.name }}
              </router-link>
            </div>
            <div class="h4 title">
              {{ $t('or visit page') }}
              <router-link :to="localizedRoute($t('/i/kontakt'))" class="pointer euppercase cl-primary-orange orange-uderline no-underline">
                {{ $t('a contact page') }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Error from '@vue-storefront/core/pages/Error'
import ButtonFull from 'theme/components/theme/ButtonFull'
import { isServer } from '@vue-storefront/core/helpers'
import { mapGetters } from 'vuex'
import groupBy from 'lodash-es/groupBy'
import config from 'config'

export default {
  name: 'Error',
  mixins: [Error],
  components: {
    ButtonFull
  },
  computed: {
    ...mapGetters('category-next', ['getMenuCategories']),
    categoriesMap () {
      return groupBy(this.getMenuCategories, 'parent_id')
    },
    mainCategoryId () {
      return config.server.categoryIdsMap.mainCategoryId
    },
    sortedCategoriesMap () {
      let arr = this.categoriesMap
      for (let key in arr) {
        arr[key].sort(this.cmpNames)
      }
      return arr
    }
  },
  methods: {
    cmpNames (a, b) {
      return a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1
    }
  },
  metaInfo () {
    return {
      meta: [
        {
          vmid: 'robots',
          name: 'robots',
          content: 'noindex, nofollow'
        }
      ]
    }
  },
  beforeRouteEnter (to, from, next) {
    if (isServer) {
      next()
    } else {
      next(vm => {
        vm.$store.commit('ui/routeChanged', { to: to, from: from })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';
$color-main: color(main);
  .big-text {
    font-size: 90px;
    @media (max-width: 1199px) {
      font-size: 80px;
    }
    @media (max-width: 767px) {
      font-size: 40px;
    }
  }
  .mw280 {
    max-width: 280px;
  }
  .button-full {
    padding: 12px;
    min-width: 280px;
    background-color:$color-main;
    color: #fff;
    font-size: 16px;
    font-weight: 400;
    text-transform: uppercase;
    border-radius: 50px;
    text-align: center;
  }
  .oops {
    font-weight: 500;
    font-size: 32px;
    text-shadow: 0 0 #b3b3b3;
    color: #676767
  }
  .orange-uderline {
    text-decoration: underline;
    color: $color-main;
  }
  .title {
    margin-bottom: 140px;
  }
  .wrap {
    flex-wrap: wrap;
  }
  @media (max-width: 767px) {
    .bottom-lg {
      align-items: center;
    }
    .mobile-link {
      display: inline-flex;
      margin: 5px;
    }
    .align-center-xs {
      text-align: center;
    }
  }
</style>
